import { render, staticRenderFns } from "./LeadProductSingle.vue?vue&type=template&id=888ede12&scoped=true&lang=pug"
import script from "./LeadProductSingle.vue?vue&type=script&lang=js"
export * from "./LeadProductSingle.vue?vue&type=script&lang=js"
import style0 from "./LeadProductSingle.vue?vue&type=style&index=0&id=888ede12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888ede12",
  null
  
)

export default component.exports